var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-bind" },
      [
        _c("van-nav-bar", { attrs: { title: "快递查询" } }),
        _vm._v(" "),
        _vm.expressList.length > 0
          ? _c(
              "div",
              { staticClass: "page-content" },
              _vm._l(_vm.expressList, function(item) {
                return _c(
                  "div",
                  [
                    _c("van-cell", {
                      attrs: { title: "快递单号" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.expressOrder) +
                                    " " +
                                    _vm._s(item.expressName) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("van-cell", {
                      attrs: { title: "物流追踪" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return _vm._l(item.list, function(item1) {
                                return _c(
                                  "div",
                                  { staticStyle: { margin: "10px 0" } },
                                  [
                                    _c("div", [_vm._v(_vm._s(item1.time))]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(item1.context) +
                                          "【" +
                                          _vm._s(item1.status) +
                                          "】"
                                      )
                                    ])
                                  ]
                                )
                              })
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              }),
              0
            )
          : _c("div", [
              _c("div", { staticClass: "page-content" }, [
                _c("fieldset", { staticClass: "md-field" }, [
                  _c("div", { staticClass: "md-field-content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-field-item md-input-item is-solid is-browser left normal"
                      },
                      [
                        _c("div", { staticClass: "md-field-item-content" }, [
                          _c("div", { staticClass: "md-field-item-control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mobile,
                                  expression: "mobile"
                                }
                              ],
                              staticClass: "md-input-item-input",
                              staticStyle: { "text-align": "center" },
                              attrs: {
                                max: "20",
                                name: "iccid",
                                placeholder: "请验证提交订单的手机号码",
                                maxlength: "",
                                autocomplete: "off",
                                type: "text"
                              },
                              domProps: { value: _vm.mobile },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.mobile = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "md-field" }, [
                  _c("div", { staticClass: "md-field-content" }, [
                    _c(
                      "button",
                      {
                        staticClass: "md-button primary active block",
                        attrs: { type: "button" },
                        on: { click: _vm.handleQuery }
                      },
                      [_vm._m(0)]
                    )
                  ])
                ])
              ])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md-button-inner" }, [
      _c("div", { staticClass: "md-button-content" }, [
        _c("span", [_vm._v("确认")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16978a9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16978a9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/express.vue
// module id = null
// module chunks = 